import React from "react";
import "../styles/Consumerbanner.css";

import img1 from "../consume-banner/assets/dicare/dicareintake1.png";
import img2 from "../consume-banner/assets/dicare/dicareintake2.png";

const DicareConsumeSection = () => {
  const steps = [
    {
      img: img1,
      title: "Step 1",
      text: "Take 1 scoop (2.5–3g) of Diacare powder",
    },
    {
      img: img2,
      title: "Step 2",
      text: "Mix it into 1 cup of lukewarm water, stir well and drink twice daily - morning and evening before meals",
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img src={step.img} alt={step.title} />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DicareConsumeSection;
